import moment from 'moment';
import React from 'react'
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background-color: ${({theme}) => theme.secondaryBgColor};
    padding-block: 20px;
    .row{
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        text-align: center;
        .col{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
        }
    }
`

const AdminFeedbackContainer = ({item}) => {
  return (
    <Container>
        <div className="row">
            <div className="col">{moment(item.createdAt).format('LLL')}</div>
            <div className="col">{item?.phoneNumber}</div>
            {item?.feedbackType === 0 && <div className="col">Yükü Aldım</div>}
            {item?.feedbackType === 1 && <div className="col">Yükü Almadım</div>}
            {item?.feedbackType === 2 && <div className="col">Belki</div>}
        </div>
    </Container>
)
}

export default AdminFeedbackContainer